export const TestIds = {
  overflow: 'internal-container-overflow',
  content: 'internal-container-content',
  backgroundLayer: 'internal-container-background-layer',
  pinnedLayer: 'internal-container-pinned-layer',
  root: 'internal-container-root',
} as const;

export const INTERNAL_CONTAINER_ROOT_CLASS = 'container';
